export default function visualizeAsPath(values, width, height) {
    if (values.length === 0) {
        for (let i=0; i<1500; i++) {
            values.push(0)
        }
    }
    const commands = [ ]

    const transformY = (y) => (height - y * height) / 2
    const addCommand = (letter, x, y) => {
        commands.push([letter, x, y].filter(a => a !== undefined).join(' '))
    }
    addCommand('M', 0, transformY(0)) // add start point


    const up = (val) => {
        addCommand('V', transformY(val))
    }
    const right = () => {
        addCommand('h', width / values.length)
    }
    const left = () => {
        addCommand('h', -width / values.length)
    }
    
    for (const val of values) {
        up(val)
        right()
    }

    for (const val of values.reverse()) {
        up(-val)
        left()
    }
    addCommand('z')
    return commands.join(' ')
}